import React, { FC } from "react";
import { Route, Routes } from "react-router-dom";

import NotFoundView from "../errors/NotFoundView";
import Cancel from "./cancel";
import Resubscribe from "./resubscribe";
import Success from "./success";
import Upgrade from "./upgrade";

const Billing: FC = () => {
  return (
    <Routes>
      <Route path="cancel" element={<Cancel />} />
      <Route path="resubscribe" element={<Resubscribe />} />
      <Route path="success" element={<Success />} />
      <Route path="upgrade" element={<Upgrade />} />
      <Route path="*" element={<NotFoundView />} />
    </Routes>
  );
};
export default Billing;
